import React from "react";
import { SETT_LABEL, FORM_LABEL, TILSTAND_LABEL } from "../../constants/dekkhotell";

// Skjema for ett dekk-/hjulsett. `idPrefix` gir unike id-er når to skjema vises samtidig.
export default function SettSkjema({ verdi, onChange, idPrefix, lasSett = false }) {
  const sett = (felt, v) => onChange({ ...verdi, [felt]: v });
  const id = (felt) => `${idPrefix}-${felt}`;
  const felt = "w-full min-w-0 rounded-xl border-2 border-slate-300 bg-white px-3 py-1.5 focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600/30";
  const etikett = "mb-1 block text-sm font-semibold text-slate-800";

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      <div>
        <label htmlFor={id("sett")} className={etikett}>Sett</label>
        <select
          id={id("sett")}
          value={verdi.sett}
          disabled={lasSett}
          onChange={(e) => sett("sett", e.target.value)}
          className={felt}
        >
          {Object.entries(SETT_LABEL).map(([k, v]) => (
            <option key={k} value={k}>{v}</option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor={id("form")} className={etikett}>Hva lagres</label>
        <select id={id("form")} value={verdi.form} onChange={(e) => sett("form", e.target.value)} className={felt}>
          {Object.entries(FORM_LABEL).map(([k, v]) => (
            <option key={k} value={k}>{v}</option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor={id("antall")} className={etikett}>Antall</label>
        <input
          id={id("antall")}
          type="number"
          min={1}
          max={4}
          value={verdi.antall}
          onChange={(e) => sett("antall", Number(e.target.value))}
          className={felt}
        />
      </div>
      <div>
        <label htmlFor={id("tilstand")} className={etikett}>Tilstand</label>
        <select
          id={id("tilstand")}
          value={verdi.tilstand}
          onChange={(e) => sett("tilstand", e.target.value)}
          className={felt}
        >
          {Object.entries(TILSTAND_LABEL).map(([k, v]) => (
            <option key={k} value={k}>{v}</option>
          ))}
        </select>
      </div>
      <div className="sm:col-span-2 lg:col-span-3">
        <label htmlFor={id("beskrivelse")} className={etikett}>Merke, modell og dimensjon</label>
        <input
          id={id("beskrivelse")}
          type="text"
          placeholder="F.eks. Schwalbe Marathon Winter Plus 42-622"
          value={verdi.beskrivelse}
          onChange={(e) => sett("beskrivelse", e.target.value)}
          className={felt}
        />
      </div>
      <div className="flex items-end">
        <label htmlFor={id("pigger")} className="flex items-center gap-2 text-sm text-slate-700 py-2">
          <input
            id={id("pigger")}
            type="checkbox"
            checked={!!verdi.pigger}
            onChange={(e) => sett("pigger", e.target.checked)}
          />
          Piggdekk
        </label>
      </div>
      <div className="sm:col-span-2 lg:col-span-4">
        <label htmlFor={id("kommentar")} className={etikett}>Kommentar (slitasje, manglende pigger, tubeless …)</label>
        <input
          id={id("kommentar")}
          type="text"
          value={verdi.kommentar}
          onChange={(e) => sett("kommentar", e.target.value)}
          className={felt}
        />
      </div>
    </div>
  );
}
